/* eslint-disable @typescript-eslint/naming-convention */
export enum EventStreamState {
  OPEN = 'Open',
  CLOSED = 'Closed',
}
